<script setup lang="ts">
import printer from "@/assets/icons/printer.svg";
import GradientIconButton from "@/components/buttons/GradientIconButton.vue";
import { defineProps, defineEmits } from "vue";

defineProps<{
  btnClasses: string | null;
  iconClasses?: string | null;
}>();

const emits = defineEmits(["click"]);
</script>

<template>
  <GradientIconButton
    :btnClasses="btnClasses"
    :iconClasses="iconClasses"
    :iconSrc="printer"
    @click="emits('click')"
  />
</template>
